import { QueryFunctionContext } from '@tanstack/react-query'
import { GET } from '../../../redux/middleware/types'
import productGroupEndpoints from '../api/productGroupEndpoints'
import productGroupQueryKeys from '../queries/productGroupQueryKeys'
import integrationRequest from '../../../services/api/integrationRequest'
import { ProductGroup } from '../../../types/product/product'

export const getProductGroups = async ({
  queryKey: [{ companyId }],
  signal
}: QueryFunctionContext<ReturnType<(typeof productGroupQueryKeys)['list']>>): Promise<ProductGroup[]> => {
  if (!companyId || companyId === 'undefined') return []
  return integrationRequest<ProductGroup[]>({
    method: GET,
    url: productGroupEndpoints.accounting(),
    signal,
    params: {
      companyId
    }
  })
}
